var _style, _path, _ellipse, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _polygon, _path8, _rect, _path9, _rect2, _path10, _rect3, _rect4, _rect5, _rect6, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _rect7, _path44, _path45, _path46, _path47, _path48;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoveOfJusticeFinal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.4;fill:#D6D7CC;}\n\t.st1{fill:#CCCCCC;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_00000178886950074086345150000007986333746318577322_);}\n\t.st4{fill:url(#SVGID_00000044884261317450276130000015081116376929271206_);}\n\t.st5{fill:url(#SVGID_00000011741511730940111170000014834210194878353319_);}\n\t.st6{fill:url(#SVGID_00000020360130391921373230000014716796971574003101_);}\n\t.st7{fill:url(#SVGID_00000166656931838132738060000008780738259222269584_);}\n\t.st8{fill:url(#SVGID_00000134950710153145324620000012822512066299838399_);}\n\t.st9{fill:#B0742A;}\n\t.st10{fill:url(#SVGID_00000137118598032424295780000006091555089791807623_);}\n\t.st11{fill:url(#SVGID_00000047775717046358415120000002441011923191172756_);}\n\t.st12{fill:url(#SVGID_00000124119357506704721800000009226162964904084926_);}\n\t.st13{fill:url(#SVGID_00000114786561671492219830000002907003154431927169_);}\n\t.st14{fill:#F0EEE3;}\n\t.st15{fill:#CDC8BD;}\n\t.st16{fill:#42210B;}\n\t.st17{fill:url(#SVGID_00000113341500354333698710000007844321270106094994_);}\n\t.st18{fill:url(#SVGID_00000119076743145459245940000001438810370244103084_);}\n\t.st19{fill:#603813;}\n\t.st20{fill:#D6D7CC;}\n\t.st21{fill:#534741;}\n\t.st22{fill:url(#SVGID_00000113330593521060159280000004560642316979380159_);}\n\t.st23{fill:#633323;}\n\t.st24{fill:#754C24;}\n\t.st25{fill:#8C6239;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.1,328.4c0,68.6,45.4,117.6,82.8,171.1c25.6,36.6,2.1,98.9-23.3,135.6c-24,34.8-38.1,76.2-38.4,120.6 c-0.9,125.3,108.4,227.7,242.7,227.3c53.7-0.2,93.1-10,136.7-31.8c42.3-21.2,128.2-26,158.8-28.2c95.3-7.1,254.1-24.7,211.7-261.1 c-9.6-53.4-107.3-101.1-120-151.7c-24.7-98.8,70.6-84.7,79.1-181.7C833.5,73.5,567.4,171,446.2,86.6 C167.4-107.5,81.1,140.3,81.1,328.4z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 453.3,
    cy: 783.5,
    rx: 434,
    ry: 121.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 465.4267,
    y1: 428.6552,
    x2: 465.4267,
    y2: 537.291
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M539.7,450H391.2c-8.8,0-15.9,7.1-15.9,15.9v5.1h180.4V466C555.6,457.2,548.5,450,539.7,450z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031165074679887164070000010237299880402844802_",
    gradientUnits: "userSpaceOnUse",
    x1: 445.7008,
    y1: 234.2616,
    x2: 485.1525,
    y2: 234.2616
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031165074679887164070000010237299880402844802_)"
    },
    d: "M477.3,30.2c-0.1-6.5-5.4-11.7-11.8-11.7 l0,0c-6.5,0-11.7,5.2-11.8,11.7L445.7,450h39.5L477.3,30.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160885631962776931100000006888526885888530565_",
    gradientUnits: "userSpaceOnUse",
    x1: 465.4268,
    y1: 454.2676,
    x2: 465.4268,
    y2: 560.3091
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160885631962776931100000006888526885888530565_)"
    },
    d: "M582.7,463.2H348.2 c-16.7,0-30.1,13.5-30.1,30.1c0,2.3,1.9,4.1,4.1,4.1h286.5c2.3,0,4.1-1.9,4.1-4.1C612.8,476.7,599.3,463.2,582.7,463.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085232229525058994500000002082533882864747423_",
    gradientUnits: "userSpaceOnUse",
    x1: 465.4267,
    y1: 62.3397,
    x2: 465.4267,
    y2: 151.7461
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 61.6,
    style: {
      fill: "url(#SVGID_00000085232229525058994500000002082533882864747423_)"
    },
    width: 346.8,
    height: 18.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123424183775396216080000011295194215505143973_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.3111,
    y1: -102.1413,
    x2: 293.3111,
    y2: 303.277
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123424183775396216080000011295194215505143973_)"
    },
    d: "M383.8,301.8L300.2,66.5 c-1-2.9-3.8-4.9-6.9-4.9c-3.1,0-5.9,2-6.9,4.9l-83.6,235.3c-1.4,3.8,0.6,8,4.4,9.4c3.8,1.4,8-0.6,9.4-4.4l76.7-215.9L370,306.7 c1.1,3,3.9,4.9,6.9,4.9c0.8,0,1.6-0.1,2.5-0.4C383.2,309.8,385.2,305.6,383.8,301.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118378631856449229420000005275370165976673469_",
    gradientUnits: "userSpaceOnUse",
    x1: 638.8796,
    y1: -102.1413,
    x2: 638.8796,
    y2: 303.277
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000118378631856449229420000005275370165976673469_)"
    },
    d: "M729.4,301.8L645.8,66.5 c-1-2.9-3.8-4.9-6.9-4.9s-5.9,2-6.9,4.9l-83.6,235.3c-1.4,3.8,0.6,8,4.4,9.4c3.8,1.4,8-0.6,9.4-4.4l76.7-215.9l76.7,215.9 c1.1,3,3.9,4.9,6.9,4.9c0.8,0,1.6-0.1,2.5-0.4C728.8,309.8,730.8,305.6,729.4,301.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018948589837881338470000012080933087498544788_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.7669,
    y1: 19.6798,
    x2: 584.9516,
    y2: 152.1581
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000018948589837881338470000012080933087498544788_)"
    },
    cx: 465.4,
    cy: 71,
    r: 33
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 465.4,
    cy: 71,
    r: 10.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090989889693567708590000004841486628400185278_",
    gradientUnits: "userSpaceOnUse",
    x1: 294.6595,
    y1: 455.1508,
    x2: 294.6595,
    y2: 251.8255
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090989889693567708590000004841486628400185278_)"
    },
    d: "M205.6,308.8 c8.9,33.7,39.4,57.1,74.2,57.1h29.7c34.8,0,65.3-23.5,74.2-57.1H205.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034054719967414056490000013973245967158100671_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.2746,
    y1: 220.2226,
    x2: 293.2746,
    y2: 416.5549
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034054719967414056490000013973245967158100671_)"
    },
    d: "M379.4,296.4H207.1 c-5.8,0-10.6,4.7-10.6,10.6v0c0,5.8,4.7,10.6,10.6,10.6h172.3c5.8,0,10.6-4.7,10.6-10.6v0C390,301.1,385.2,296.4,379.4,296.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127011462814866544840000006463630326743861949_",
    gradientUnits: "userSpaceOnUse",
    x1: 640.2281,
    y1: 455.1508,
    x2: 640.2281,
    y2: 251.8255
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127011462814866544840000006463630326743861949_)"
    },
    d: "M625.4,365.9h29.7 c34.8,0,65.3-23.5,74.2-57.1H551.2C560.1,342.5,590.5,365.9,625.4,365.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015354860960504315790000014180128063396120968_",
    gradientUnits: "userSpaceOnUse",
    x1: 638.8431,
    y1: 220.2226,
    x2: 638.8431,
    y2: 416.5549
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000015354860960504315790000014180128063396120968_)"
    },
    d: "M725,296.4H552.7 c-5.8,0-10.6,4.7-10.6,10.6v0c0,5.8,4.7,10.6,10.6,10.6H725c5.8,0,10.6-4.7,10.6-10.6v0C735.5,301.1,730.8,296.4,725,296.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M647.9,498.8H447H240.5c0,0-30.4,10.1-29.8,46.7c0.6,36.5,29.8,46.7,29.8,46.7h206.8h200.6V498.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M647.9,531.6H211.4c0.4-2.3,0.9-4.4,1.5-6.4h434.9V531.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M647.9,548.7H211.1c-0.2-2-0.4-4.1-0.4-6.4v0h437.2V548.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M647.9,565.8h-432c-1-2-1.8-4.1-2.6-6.4h434.5V565.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M647.9,576.5v6.4h-418c-2.2-1.7-4.6-3.8-6.8-6.4H647.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "273.6,521.8 289.4,521.8 312.5,521.8 312.5,569.8 310.4,593 306.9,593 289.4,576.5 265.7,593 262,593  "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M653.5,505.2H447H240.5c0.5,0,1.1-0.1,1.6-0.3c-1.1,0.4-26.3,9.4-25.8,40.4c0.5,31.3,24.9,40.3,25.9,40.7 c-0.5-0.2-1.1-0.3-1.6-0.3h206.8h206.2c3.1,0,5.6,2.9,5.6,6.4c0,3.5-2.5,6.4-5.6,6.4H447.3H240.5c-0.5,0-1.1-0.1-1.6-0.3 c-11.5-4-33.3-20.1-33.8-52.7c-0.5-32.8,21.9-49,33.9-53c0.5-0.2,1-0.3,1.6-0.3H447h206.5c3.1,0,5.6,2.9,5.6,6.4 C659,502.4,656.5,505.2,653.5,505.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010307645446034372340000016495541399102617279_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.2677,
    y1: 734.2929,
    x2: 588.0703,
    y2: 326.017
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000010307645446034372340000016495541399102617279_)"
    },
    points: "273.6,595.9 296.7,576.5  319.8,595.9 319.8,569.8 319.8,521.8 296.7,521.8 273.6,521.8 273.6,569.8 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004533882860884514340000003509758609615961515_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.8978,
    y1: 726.3235,
    x2: 581.7004,
    y2: 318.0476
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000004533882860884514340000003509758609615961515_)"
    },
    points: "319.8,569.8 319.8,521.8  296.7,521.8 273.6,521.8 "
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 112.1,
    y: 609.1,
    className: "st14",
    width: 495.7,
    height: 78.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M101.5,686.1c-3.9,0-7.1,3.3-7.1,7.3c0,4,3.2,7.3,7.1,7.3h517.1c3.9,0,7.1-3.3,7.1-7.3c0-4-3.2-7.3-7.1-7.3 H101.5z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 112.1,
    y: 609.1,
    className: "st20",
    width: 495.7,
    height: 19.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M101.5,598.6c-3.9,0-7.1,3.3-7.1,7.3c0,4,3.2,7.3,7.1,7.3h517.1c3.9,0,7.1-3.3,7.1-7.3c0-4-3.2-7.3-7.1-7.3 H101.5z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 112.1,
    y: 616.8,
    className: "st15",
    width: 495.7,
    height: 7.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 112.1,
    y: 636.3,
    className: "st15",
    width: 495.7,
    height: 7.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 112.1,
    y: 655.7,
    className: "st15",
    width: 495.7,
    height: 7.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 112.1,
    y: 675.2,
    className: "st15",
    width: 495.7,
    height: 7.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M173.6,707.3h228.5h234.8c0,0,34.6,11.5,33.9,53.1c-0.7,41.6-33.9,53.1-33.9,53.1H401.7H173.6V707.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M173.6,707.3V729h489.3c-10-16.4-25.9-21.7-25.9-21.7H402.1H173.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M173.6,725.2h489.1c-1.7-2.7-3.5-5.2-5.5-7.3H173.6V725.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M173.6,744.7H670c-0.4-2.6-1-5-1.7-7.3H173.6V744.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M173.6,764.1h496.8c0.3-2.3,0.4-4.7,0.5-7.2v0H173.6V764.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M173.6,783.5h491.3c1.1-2.3,2.1-4.7,2.9-7.3H173.6V783.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M173.6,795.7v7.3H649c2.5-1.9,5.2-4.4,7.8-7.3H173.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M167.3,714.6h234.8h234.8c-0.6,0-1.2-0.1-1.8-0.3c1.2,0.4,29.9,10.7,29.4,46c-0.6,35.6-28.3,45.8-29.4,46.3 c0.6-0.2,1.2-0.3,1.9-0.3H401.7H167.3c-3.5,0-6.4,3.3-6.4,7.3c0,4,2.8,7.3,6.4,7.3h234.5h235.2c0.6,0,1.2-0.1,1.8-0.3 c13-4.5,37.8-22.9,38.4-59.9c0.6-37.3-24.9-55.7-38.5-60.2c-0.6-0.2-1.2-0.3-1.8-0.3H402.1H167.3c-3.5,0-6.4,3.3-6.4,7.3 C160.9,711.4,163.8,714.6,167.3,714.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000913793001761278330000001019768521232360593_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.0508,
    y1: 334.3909,
    x2: 1172.2579,
    y2: 975.1467
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000000913793001761278330000001019768521232360593_)"
    },
    points: "583.3,692.9 475,627.7  521.7,550.3 629.9,615.4  "
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M581.1,574l-52.5-31.6c0,0,4.4-1.2,9.8-2.8c5.4-1.5,8.8-7.2,7.6-12.7l-2.1-9.9l52.5,31.6l52.5,31.6 c0,0-4.4,1.2-9.8,2.8c-5.4,1.5-8.8,7.2-7.7,12.7l2.1,9.9L581.1,574z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M519.2,529.3c-0.3,0.1-0.5,0.3-0.6,0.5c-6,9.9-5.7,21.1,0.8,25l107.6,64.8c6.4,3.9,16.5-1.1,22.4-11 c0.1-0.2,0.2-0.5,0.2-0.8L519.2,529.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M557.2,554.3l-0.4,0.3c-3.4,5.7-2.7,12.4,1.7,15l72.7,43.8c4.3,2.6,10.6,0.1,14-5.5l0.1-0.5L557.2,554.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M654.4,582.9c-1.2,2-3,3.1-4,2.6l-111.9-67.4c-1-0.6-0.8-2.7,0.4-4.7c1.2-2,3-3.2,4-2.6l111.9,67.4 C655.8,578.8,655.6,580.9,654.4,582.9z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M678.2,543.4c-1.2,2-3,3.2-4,2.6l-111.9-67.4c-1-0.6-0.8-2.7,0.4-4.7c1.2-2,3-3.2,4-2.6l111.9,67.4 C679.6,539.2,679.4,541.4,678.2,543.4z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M674.8,567.9c-6.1,10.1-18.8,13.5-28.5,7.7l-97.1-58.4c-9.7-5.8-12.6-18.7-6.5-28.8 c6.1-10.1,18.8-13.5,28.5-7.7l97.1,58.4C677.9,544.9,680.8,557.8,674.8,567.9z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M670.7,564.4c-3.1,5.1-11,6.1-17.6,2.1l-66.4-40c-6.6-4-9.5-11.4-6.4-16.5c3.1-5.2,11-6.1,17.6-2.1l66.4,40 C671,551.9,673.8,559.3,670.7,564.4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M675.7,540.5c-0.4,0.7-1.5,0.8-2.5,0.2l-65.3-39.3c-1-0.6-1.4-1.6-1-2.3c0.4-0.7,1.5-0.8,2.5-0.2l65.3,39.3 C675.7,538.8,676.1,539.8,675.7,540.5z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M653.2,579c-0.6,1-2.3,1-3.8,0.1l-80.6-48.5c-1.5-0.9-2.2-2.4-1.7-3.4c0.6-1,2.3-1,3.8-0.1l80.6,48.5 C653,576.6,653.7,578.1,653.2,579z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M521.4,673.1l-52.5-31.6c0,0,1,4.5,2.1,9.9c1.2,5.5-2.2,11.2-7.7,12.7l-9.8,2.8l52.5,31.6l52.5,31.6 c0,0-1-4.4-2.1-9.9c-1.2-5.5,2.2-11.2,7.7-12.7l9.8-2.8L521.4,673.1z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M453,639.3c0-0.3,0-0.6,0.2-0.8c6-10,16-14.9,22.4-11l107.5,64.7c6.4,3.9,6.7,15,0.7,25 c-0.1,0.2-0.3,0.4-0.6,0.5L453,639.3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M492.8,661.3l0.1-0.5c3.4-5.7,9.7-8.1,14-5.5l72.7,43.8c4.3,2.6,5.1,9.3,1.7,15l-0.4,0.3L492.8,661.3z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M563.6,733.7c1.2-2,1.4-4.1,0.4-4.7l-111.9-67.3c-1-0.6-2.8,0.6-4,2.6c-1.2,2-1.4,4.1-0.4,4.7l111.9,67.3 C560.6,736.9,562.4,735.8,563.6,733.7z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M539.8,773.3c1.2-2,1.4-4.1,0.4-4.7l-111.9-67.4c-1-0.6-2.8,0.6-4,2.6c-1.2,2-1.4,4.1-0.4,4.7l111.9,67.3 C536.8,776.4,538.6,775.3,539.8,773.3z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M559.8,758.8c6.1-10.1,3.1-23-6.5-28.8l-97.1-58.4c-9.7-5.8-22.4-2.4-28.5,7.7c-6.1,10.1-3.1,23,6.5,28.8 l97.1,58.4C541,772.3,553.8,768.9,559.8,758.8z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M554.9,756.8c3.1-5.1,0.2-12.5-6.4-16.5l-66.4-40c-6.6-4-14.5-3-17.6,2.1c-3.1,5.1-0.2,12.5,6.4,16.5l66.4,40 C544,762.9,551.8,762,554.9,756.8z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M536.1,772.4c0.4-0.7,0-1.7-1-2.3l-65.3-39.3c-0.9-0.6-2.1-0.5-2.5,0.2c-0.4,0.7,0,1.7,1,2.3l65.3,39.3 C534.6,773.2,535.7,773.1,536.1,772.4z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M559.6,734.4c0.6-1-0.2-2.5-1.7-3.4l-80.6-48.5c-1.5-0.9-3.2-0.8-3.8,0.1c-0.6,1,0.2,2.5,1.7,3.4l80.6,48.5 C557.3,735.5,559,735.4,559.6,734.4z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M896.3,804.9c-34.6-21.8-144.8-83.1-144.8-83.1s-77.9-46.9-82.1-49.4c-4.2-2.5-10.7-9.5-15.1-15.1 c-3.3-4.2-6.4-7.5-9.1-9.1c-13-7.8-29.8-3.6-37.6,9.3c-7.8,13-3.6,29.8,9.3,37.6c2.7,1.6,7.1,2.9,12.3,3.8c7,1.3,16.4,3.8,20.7,6.4 l81.8,49.2c0,0,112.9,72,141.2,89.1c28.3,17.1,73.8,40.4,73.8,40.4c9.2,5.5,21.1,2.7,26.5-6.4c5.4-9,2.4-20.9-6.8-26.4 C966.5,851.2,930.9,826.7,896.3,804.9z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M661.7,677.8c-2,5.6-24.6,0.5-30.8-3.2c-6.2-3.7-8.2-11.8-4.5-18c3.7-6.2,11.8-8.2,18-4.5 C650.6,655.8,663.6,672.2,661.7,677.8z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M962.7,862.2c-3.3,5.6-51-23.5-110-59c-59-35.5-105.6-66.4-103.6-69.6c2-3.2,51,23.5,110,59 C918.1,828.1,966,856.5,962.7,862.2z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M664,709.2c-2.2,3.7-7,4.9-10.7,2.7c-3.7-2.2-4.9-7-2.7-10.7l15.7-26.1c2.2-3.7,7-4.9,10.7-2.7 c3.7,2.2,4.9,7,2.7,10.7L664,709.2z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M668.6,697.2c-1.3,2.2-4.2,3-6.3,1.7c-2.2-1.3-2.8-4.2-1.5-6.4l9.5-15.7c1.3-2.2,4.2-3,6.3-1.7 c2.2,1.3,2.8,4.2,1.5,6.4L668.6,697.2z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M603.6,679.4c-1.9,3.1-5.9,4.1-9,2.2c-3.1-1.9-4.1-5.8-2.2-8.9l21.5-35.7c1.9-3.1,5.9-4.1,8.9-2.2 c3.1,1.9,4.1,5.9,2.2,9L603.6,679.4z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M608,668.4c-0.9,1.5-2.9,2-4.4,1.1c-1.5-0.9-2-2.9-1.1-4.4l15.6-26c0.9-1.5,2.9-2,4.4-1.1 c1.5,0.9,2,2.9,1.1,4.4L608,668.4z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 335.3,
    y: 792.5,
    className: "st23",
    width: 381.2,
    height: 80.7
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M729.2,875.3c0,6.4-6.3,11.6-14,11.6H336.7c-7.7,0-14-5.2-14-11.6c0-6.4,6.3-11.6,14-11.6h378.6 C723,863.7,729.2,868.9,729.2,875.3z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M729.2,799.4c0,6.4-6.3,11.6-14,11.6H336.7c-7.7,0-14-5.2-14-11.6c0-6.4,6.3-11.6,14-11.6h378.6 C723,787.8,729.2,793,729.2,799.4z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M729.2,777.3c0,6.4-6.3,11.6-14,11.6H336.7c-7.7,0-14-5.2-14-11.6c0-6.4,6.3-11.6,14-11.6h378.6 C723,765.6,729.2,770.8,729.2,777.3z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M721.7,773.5c0,2.8-2.3,5-5,5H425.4c-2.8,0-5-2.3-5-5c0-2.8,2.3-5,5-5h291.3 C719.5,768.4,721.7,770.7,721.7,773.5z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M721.7,796c0,2.8-2.3,5.1-5,5.1H425.4c-2.8,0-5-2.3-5-5.1c0-2.8,2.3-5,5-5h291.3 C719.5,791,721.7,793.2,721.7,796z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveOfJusticeFinal);
export default __webpack_public_path__ + "static/media/love_of_justice_final.dfbfee71343455db6a893c29ecea5924.svg";
export { ForwardRef as ReactComponent };